function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path fill="currentColor" d="M9 0h6v9h9v6h-9v9H9v-9H0V9h9V0Z" />
    </svg>
  );
}

export default Icon;
